import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Caroussel from "./CarousselHome";
import FirstSection from "./Timeline";


const Sections = () => {

  return (
    <>
      <>
        <Caroussel />
        <FirstSection />
      </>
    </>
  );
};
export default Sections;
